import { Component, OnInit, Input, HostListener, ElementRef } from '@angular/core'
import { NavService } from '../../services/nav.service'


@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {
  public state = 'hide'

  @Input() headline: string
  @Input() copy: string
  @Input() large_tagline: string
  @Input() _editable: any
  constructor(
    public el: ElementRef,
    private nav: NavService
  ) { }

  ngOnInit() {
  }

  @HostListener('window:scroll', ['$event'])
  checkScroll() {
    const tag = document.getElementById('tag')
    const aboutSection = document.getElementById('aboutInner')
    let scrollPosition = window.pageYOffset
    let left = scrollPosition / 6
    let top = scrollPosition / 3
    
    if ( this.isElementInViewport(aboutSection) ) {
      this.animate(
        tag, 
        'translate('+ (left - (tag.offsetLeft + 80)) +'px, '+ (top - (tag.offsetTop + 20)) + 'px' + ')',
        '1'
      )
    } else {
      tag.style.opacity = '0'
    }
  }

  animate (el, transform, opacity) {  
    el.style.transform = transform
    el.style.opacity = opacity
  }

  isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document. documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document. documentElement.clientWidth)
    )
  }

  public onIntersection({ target, visible }, id): void {
    if(visible) {
      this.nav.changeActiveNavItem(id)
    }
  }
}
